import React, { ReactElement } from 'react';
import loadable from '@loadable/component';
import { Route, Routes } from 'react-router';
import S from './Styles';
import { NafCenterAppType } from '../../../types/CategoryAppType';
import { NotFound } from '../loadable-elements/NotFound';

export const nafCenterBasePath = 'bilverksted-og-tester';
const NafCenterServices = loadable(() => import('../pages/nafCenter/services'), {
  resolveComponent: (m) => m.NafCenterServices,
});

export const nafCenterPath = 'naf-senter/:centerSlug';

const NafCenterPageRoute = loadable(() => import('./NafCenterPageRoute'), {
  resolveComponent: (m) => m.NafCenterPageRoute,
});

const NafCentersDocumentRoute = loadable(() => import('./NafCentersDocumentRoute'), {
  resolveComponent: (m) => m.NafCentersDocumentRoute,
});

export const NafCenterRouter = ({
  data,
  slug,
  appData,
}: {
  data?: any;
  slug?: string;
  appData?: NafCenterAppType;
}): ReactElement => (
  <S.Wrapper>
    <Routes>
      {slug && <Route path={slug} element={<NafCenterServices slug={slug} data={data} appData={appData} />} />}
      <Route path={`${nafCenterBasePath}/${nafCenterPath}`} element={<NafCenterPageRoute />} />
      <Route path={`${nafCenterBasePath}/:slug`} element={<NafCentersDocumentRoute />} />
      <Route path={`${nafCenterBasePath}/:parentSlug/:slug`} element={<NafCentersDocumentRoute />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </S.Wrapper>
);
